module.exports = __webpack_public_path__ + "img/menu.b684665c.svg";